import { makeAutoObservable } from 'mobx';
import { validateLimitOrder } from './validateLimitOrder';

export class LimitOrderData {
  limitPrice = 0;
  quantityBasisValue = 0;
  offsetFromSetupPrice = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.limitPrice = 0;
    this.quantityBasisValue = 0;
    this.offsetFromSetupPrice = 0;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = (tradePlan) => {
    const data = {
      quantityBasisValue: this.quantityBasisValue,
      tradePlan,
    };
    const result = validateLimitOrder(data);
    return result;
  };
  returnJson = () => {
    return {
      limitPrice: this.limitPrice,
      quantityBasisValue: this.quantityBasisValue,
      offsetFromSetupPrice: this.offsetFromSetupPrice,
    };
  };

  //specific methods
  setLimitPrice = (number) => {
    this.limitPrice = number;
  };
  setQuantityBasisValue = (number) => {
    this.quantityBasisValue = number;
  };
  setOffsetFromSetupPrice = (number) => {
    this.offsetFromSetupPrice = number;
  };
}
